module.exports = __webpack_public_path__ + "img/servizi.d3fb31bb.jpeg";